import React from 'react';
import UserSearchInput from 'components/inputs/UserSearchInput';
import Button from 'components/common/Button';
import Form from 'components/common/Form';
import FormItem from 'components/common/FormItem';

class AddTeamMemberForm extends React.PureComponent {
  state = {
    user: null,
  };

  onUserChange = user => {
    this.setState({
      user: {
        value: user._id,
        label: `${user.profile.firstName} ${user.profile.firstName} - ${user.emails[0].address}`,
      },
    });
  };

  onSubmit = () => {
    let userId = this.state.user.value;
    this.props.handleSubmit(userId);
  };

  render() {
    return (
      <Form>
        <FormItem label="User to add">
          <UserSearchInput value={this.state.user} onChange={this.onUserChange} />
        </FormItem>
        <FormItem>
          <Button onClick={this.onSubmit}>{this.props.buttonLabel}</Button>
        </FormItem>
      </Form>
    );
  }
}

AddTeamMemberForm.defaultProps = {
  buttonLabel: 'Add User',
};

export default AddTeamMemberForm;



// WEBPACK FOOTER //
// ./src/components/forms/AddTeamMemberForm/index.js